import { prefixerM } from './common'

export const ROUTE_CONFIGURAR_TIPO_ACTIVO_FIJO = prefixerM('tipo-activo')

export const ROUTE_GESTION_PLANTILLA_ACTIVO_FIJO = prefixerM('gestion-plantilla-activo-fijo')

export const ROUTE_PLANTILLA_ACTIVO_FIJO = prefixerM('plantilla-activo-fijo')

export const ROUTE_CONFIGURAR_ITEM_ACTIVO_FIJO = prefixerM('item-activo-fijo')
